"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const modal_1 = require("components/cosmos/v2/modal");
const form_1 = require("components/form");
const input_1 = require("components/input");
const translationContext_1 = require("configs/translationContext");
const differenceWith_1 = __importDefault(require("lodash/differenceWith"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const services_1 = require("modules/app/services");
const clickFreeModuleGoBackSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleGoBackSchema");
const clickFreeModuleSaveSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleSaveSchema");
const viewFreeModuleModalSchema_1 = require("modules/app/services/datahubEvents/freeModule/viewFreeModuleModalSchema");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const salesManager_1 = require("modules/salesManager");
const OfferPanelRadioList_1 = __importDefault(require("modules/salesManager/salesInfo/OfferPanelRadioList"));
const signUpModal_1 = require("./signUpModal");
const PersonalizeSalesPage = ({ offers, classes, onPreviousStep, onEnableFreeModule }) => {
    const [description, setDescription] = (0, react_1.useState)();
    const [selectedOffers, setSelectedOffers] = (0, react_1.useState)([]);
    const [items, setItems] = (0, react_1.useState)([]);
    const { t } = (0, translationContext_1.useTranslation)();
    const subdomain = MembershipService_1.default.subdomain;
    (0, react_1.useEffect)(function mountItems() {
        const items = salesManager_1.SalesService.addClass(offers, classes);
        setItems(items);
    }, [offers, classes]);
    (0, react_1.useEffect)(() => {
        const schema = new viewFreeModuleModalSchema_1.ViewFreeModuleModalSchema({
            step: signUpModal_1.ViewFreeModuleSteps.SALES_PAGE_CUSTOMIZE
        });
        services_1.DatahubEventsService.sendEvent({ schema });
    }, []);
    const onUncheckItem = (selectedItem) => {
        const newSelectedOffers = selectedOffers.filter((item) => item.offerKey !== selectedItem.offerKey);
        setSelectedOffers(newSelectedOffers);
    };
    const onCheckItem = (selectedItem, name) => {
        let selectedItems = [];
        if (name && offers[name] && (0, isArray_1.default)(offers[name])) {
            selectedItems = (0, differenceWith_1.default)(selectedOffers, offers[name], salesManager_1.SalesService.isOfferMatch);
        }
        else {
            selectedItems = (0, differenceWith_1.default)(selectedOffers, offers, salesManager_1.SalesService.isOfferMatch);
        }
        selectedItems.push(selectedItem);
        setSelectedOffers(selectedItems);
    };
    const handleGoBack = () => {
        const schema = new clickFreeModuleGoBackSchema_1.ClickFreeModuleGoBackSchema({
            componentName: 'FreeModuleModalSalesGoBackButton'
        });
        services_1.DatahubEventsService.sendEvent({ schema });
        onPreviousStep();
    };
    const handleSubmit = async () => {
        await salesManager_1.SalesService.saveFreeSignup({
            description,
            offers: selectedOffers,
            allowSignup: true
        }, subdomain);
        const schema = new clickFreeModuleSaveSchema_1.ClickFreeModuleSaveSchema();
        services_1.DatahubEventsService.sendEvent({ schema });
        onEnableFreeModule();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("span", { className: "_text-3 _font-weight-light _text-gray-700", children: t('general.sales_page') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: "_d-flex _align-items-center _flex-column", children: [(0, jsx_runtime_1.jsx)("span", { className: "_text-2 _text-gray-500", children: t('module_editor.active_free_signup.step3.subtitle') }), (0, jsx_runtime_1.jsxs)(form_1.Form, { className: "sales_info", children: [(0, jsx_runtime_1.jsx)("label", { id: "description", className: "_text-2 _text-gray-900 _mb-2", children: t('general.description') }), (0, jsx_runtime_1.jsx)(input_1.Input, { placeholder: "general.editor_placeholder", value: description, onChange: (e) => setDescription(e.target.value), name: "description", type: "textarea", className: "description__textarea" }), (0, jsx_runtime_1.jsx)("span", { className: "_text-1 _text-gray-500 _mt-2", children: t('module_editor.active_free_signup.step3.description') }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(tooltip_1.default, { content: t('sales_manager.sales_info.price.description'), children: (0, jsx_runtime_1.jsxs)("label", { id: "offersRadioList", children: [t('general.price'), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'circle-question'], className: "_ml-2" })] }) }), (0, jsx_runtime_1.jsx)(form_1.FormControl, { "data-test": "offer-panel", children: (0, jsx_runtime_1.jsx)(OfferPanelRadioList_1.default, { required: true, name: "offersRadioList", value: selectedOffers, panelLabel: "sales_manager.sales_info.choose_offer", items: items, selectedOffers: selectedOffers, allowUncheck: true, onUncheckItem: onUncheckItem, onCheckItem: onCheckItem }) })] })] })] }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _justify-content-end _w-full", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "tertiary", className: "_mr-2", onClick: handleGoBack, children: t('general.back') }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", onClick: handleSubmit, disabled: selectedOffers.length === 0, children: t('general.save') })] })] }));
};
exports.default = PersonalizeSalesPage;
